import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/upload.svg";
var UploadSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  UploadSolid_default as default
};
